/* @flow */
import React from 'react';

import cx from 'classnames';
import './styles/BoxTitle.scss';

class BoxTitle extends React.Component {
  static propTypes = {
    title: React.PropTypes.node,
  };

  renderTitle = () => {
    const { title } = this.props;
    if (!title) {
      return null;
    }

    return title;
  };

  render() {
    const title = this.renderTitle();

    return (
      <h2 className={cx('BoxTitle', this.props.className)}>
        {title}
        {this.props.children}
      </h2>
    );
  }
}

export default BoxTitle;



// WEBPACK FOOTER //
// ./src/components/BoxTitle.jsx